import React, { useState } from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer'; // Import the hook
import '../styles/home.css'; // Import styles from styles/home.css
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Slide } from '@mui/material'; // Optional animation

const Home = () => {
  const [formData, setFormData] = useState({
    emri: "",
    emaili: "",
    website: "",
    nrTelefonit: "",
    mesazhi: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success, error, warning, info


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://d3ejxze7429gw1.cloudfront.net/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSnackbarMessage("Form submitted successfully!");
        setSnackbarSeverity("success");
      } else {
        setSnackbarMessage(result.message || "Failed to submit form.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error); // Log the error
      setSnackbarMessage("An error occurred. Please try again.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true); // Open the snackbar after the operation
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Scroll animations using useInView
  const [heroRef, heroInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ceramicRef, ceramicInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [benefitsRef, benefitsInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [contactRef, contactInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [whyRef, whyInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [getInTouchRef, getInTouchInView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <>
      <div className="home-container">
        {/* Hero Section */}
        <section
          className={`hero-section ${heroInView ? 'fade-in' : ''}`}
          ref={heroRef}
        >
          <div className="hero-content">
            <h1 className="hero-title">Zbuloni Artin e Elegancës: Ronni Ceramics</h1>
            <button className="hero-button">SHIKO PRODUKTET</button>
          </div>
        </section>
      </div>

      {/* Ceramic Tiles Section */}
      <section
        className={`ceramic-tiles-section ${ceramicInView ? 'slide-in-left' : ''}`}
        ref={ceramicRef}
      >
        <div className="ceramic-image">
          <img src="/images/foto1.png" alt="Ceramic Tiles" className="ceramic-main-img" />
        </div>
        <div className="ceramic-content">
          <span className="ceramic-subtitle">
            <span className="icon-box"></span> ZBULO KOLEKSIONET TONA
          </span>
          <h2 className="ceramic-title">Pllaka Çeramike me cilësi shumë të lartë</h2>
          <p className="ceramic-description">
            Tekstura të ndryshme kualitative që tregojnë koleksionin më tërheqës dhe unik të pllakave çeramike dhe produkteve sanitare të ofruara nga Ronni Ceramics.
          </p>
          <div className="ceramic-thumbnail">
            <img src="/images/foto2.png" alt="Tile Texture" />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section
        className={`benefits-section ${benefitsInView ? 'slide-in-right' : ''}`}
        ref={benefitsRef}
      >
        <div className="benefits-content">
          <span className="benefits-subtitle">
            <span className="icon-box"></span> BENEFITET E JUAJA
          </span>
          <h2 className="benefits-title">Fokusohuni në cilësinë që ne ofrojmë</h2>

          <div className="benefits-accordion">
            {accordionData.map((item, index) => (
              <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
                <button className="accordion-title" onClick={() => toggleAccordion(index)}>
                  {activeIndex === index ? '−' : '+'} {item.title}
                </button>
                <div className="accordion-content">{item.content}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="benefits-image">
          <img src="/images/foto3.png" alt="Ceramic Floor" className="benefits-main-img" />
        </div>
      </section>

      {/* Contact Section */}
      <section
        className={`contact-section ${contactInView ? 'fade-in' : ''}`}
        ref={contactRef}
      >
        <div className="contact-overlay"></div>

        <div className="contact-content">
          <span className="contact-subtitle">
            <span className="icon-box"></span> NA KONTAKTONI
          </span>
          <h2 className="contact-title">
            RonniCeramics do t'ju ndihmojë t'i bëni projektet e juaja në realitet.
          </h2>
          <p className="contact-description">
            Ne arrijmë fleksibilitet dhe cilësi me produkte të ndryshme, dhe me përfaqësues global të brendeve të qeramikës!
          </p>
          <a href="/contact-us" className="aButtoni">
            <button className="contact-button">NA KONTAKTONI</button>
          </a>
        </div>

        <div className="contact-stats">
          <div className="stat-box">
            <h3>23+</h3>
            <p>Projekte të nënkontraktuara</p>
          </div>
          <div className="stat-box">
            <h3>50+</h3>
            <p>Projekte në pritje</p>
          </div>
          <div className="stat-box">
            <h3>10+</h3>
            <p>Katalogje</p>
          </div>
          <div className="stat-box">
            <h3>2+</h3>
            <p>Vite Eksperiencë</p>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section
        className={`why-choose-us-section ${whyInView ? 'slide-in-left' : ''}`}
        ref={whyRef}
      >
        <div className="why-image">
          <img src="/images/foto5.png" alt="Luxury Interior" className="why-main-img" />
        </div>

        <div className="why-content">
          <span className="why-subtitle">
            <span className="icon-box"></span> PSE TË NA ZGJEDHNI NE?
          </span>
          <h2 className="why-title">Ne jemi më të mirët</h2>
          <p className="why-description">
            Qëndrueshmëria e produktit tonë mbështet optimizimin e lëndëve të para me shumë përparësi për sektorët e ndërtimit dhe banesave.
          </p>

          <div className="why-benefits">
            <div className="benefit-item"><span>1</span> Qëndrueshmëri</div>
            <div className="benefit-item"><span>2</span> Shëndeti dhe siguria</div>
            <div className="benefit-item"><span>3</span> Metodat moderne</div>
            <div className="benefit-item"><span>4</span> Shërbim profesional</div>
          </div>

          <div className="why-rating">
            <div className="rating-label">
              <span>E qëndrueshme</span>
              <span>93%</span>
            </div>
            <div className="rating-bar">
              <div className="rating-fill" style={{ width: '93%' }}></div>
            </div>
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p className="rating-text">
              5,00 Mesatarja Bazuar në Vlerësimin 50 – <a href="#">Më shumë informacion</a>
            </p>
          </div>
        </div>
      </section>

      {/* Get in Touch Section */}
      <section
        className={`get-in-touch-section ${getInTouchInView ? 'slide-in-right' : ''}`}
        ref={getInTouchRef}
      >
        <div className="get-in-touch-container">
        
      <form onSubmit={handleSubmit}>
      <h3>Na Kontaktoni</h3>
        <div className="input-group">
          <input
            type="text"
            name="emri"
            placeholder="Emri"
            value={formData.emri}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="emaili"
            placeholder="E-Mail"
            value={formData.emaili}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-group">
          <input
            type="text"
            name="nrTelefonit"
            placeholder="Numri i telefonit"
            value={formData.nrTelefonit}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="website"
            placeholder="Faqja juaj e internetit"
            value={formData.website}
            onChange={handleChange}
          />
        </div>

        <textarea
          name="mesazhi"
          placeholder="Mesazhi juaj këtu"
          value={formData.mesazhi}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit" className="get-in-touch-button">
          PARAQISNI TANI
        </button>
      </form>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000} // Adjust as needed
        onClose={handleCloseSnackbar}
        TransitionComponent={Slide} // Optional animation
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}  // Adjust position
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    
      

          <div className="get-in-touch-info">
            <div className="get-in-touch-box">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>Lokacioni</h3>
                <p>
                  Objekti BK Center (Kati 1),<br />
                  Rr. "Ismail Raka" - Kaçanik 71000
                </p>
              </div>
            </div>

            <div className="get-in-touch-box">
              <i className="fas fa-envelope"></i>
              <div>
                <h3>Emaili</h3>
                <p>roniceramics@gmail.com</p>
              </div>
            </div>

            <div className="get-in-touch-box">
              <i className="fas fa-phone-alt"></i>
              <div>
                <h3>Na Thirrni</h3>
                <p>
                  +38344555951<br />
                  +38344124889
                </p>
              </div>
            </div>
          </div>

          <div className="get-in-touch-image">
            <img src="/images/foto6.png" alt="Modern Kitchen" />
          </div>
        </div>
      </section>
    </>
  );
};

const accordionData = [
  {
    title: 'Larmi e Veçantë',
    content:
      'Zgjidhni nga një zgjedhje e gjerë pllakash qeramike në katalogë të ndryshme, madhësi, ngjyra dhe forma për t’i përshtatur çdo preference dizajni.',
  },
  {
    title: 'Cilësi e Lartë',
    content: 'Materiale të forta dhe të qëndrueshme me përfundime të përkryera për çdo ambient.',
  },
  {
    title: 'Mundësi Pafund',
    content: 'Përzgjedhje e pasur e modeleve për të përmbushur çdo kërkesë estetike dhe funksionale.',
  },
];

export default Home;